import React, { useEffect, useState } from 'react';
import { post } from '../Auths/AuthToken';
import { useSelector } from 'react-redux';
import setUiMessage from '../../Utilities/Tostify';

function TeleMedicineSection({
  appointmentId,
  telemedicine,
  telemedicineMode,
  telemedicineQcode,
  returnDatafunc,
}) {
  const { user } = useSelector((state) => state.auth);

  const [fieldId, setFieldId] = useState(0);
  const [telemed, setTeleMed] = useState(telemedicine);
  const [telemedQcode, setTelemedQcode] = useState(parseInt(telemedicineQcode));
  const [teleMedMode, setTeleMedMode] = useState(parseInt(telemedicineMode));

  useEffect(() => {
    returnDatafunc(telemed);
  }, [returnDatafunc, telemed]);

  const handleTelemed = (e, fid) => {
    const { checked } = e.target;
    setFieldId(fid);
    if (fid === 1) {
      setTelemedQcode(checked ? 1 : 0);
    } else {
      setTeleMed(checked ? '1' : '0');
      setTelemedQcode(0);
      setTeleMedMode(1);
    }
    handleTeleMedecine(appointmentId, e.target.checked, fid);
  };

  const handleTeleMedecine = async (appointmentId, telemed, fieldId) => {
    try {
      const response = await post(
        'api/patient/progressNote/updateAppointmentTelemedicine',
        {
          appointmentId: appointmentId,
          telemedicine: telemed ? '1' : '0',
          fieldId: fieldId,
          staffUserId: user.id,
        }
      );
      if (response.status === 200) {
      }
    } catch (err) {
      setUiMessage('err', err.message);
    }
  };

  const handleTelMedMode = async (e) => {
    try {
      const response = await post(
        'api/patient/progressNote/updateAppointmentTelemedicineMode',
        {
          appointmentId: appointmentId,
          fieldVal: e.target.value,
          staffUserId: user.id,
        }
      );
      if (response.status === 200) {
        setTeleMedMode(e.target.value);
      }
    } catch (err) {
      setUiMessage('err', err.message);
    }
  };

  return (
    <>
      <span className="pop-up-sb-hdr">Service</span>
      <div className="appt-hx-fa-rw">
        <input
          type="checkbox"
          className="clear-right10"
          onChange={(e) => handleTelemed(e, 0)}
          checked={telemed === '1' ? true : false}
        />
        Telemedicine
        <div
          className={
            telemed === '0' && fieldId === 0 ? 'hide' : 'qappt-hx-fa-rw'
          }
        >
          <input
            type="radio"
            name="serviceType"
            className="clear-left10 clear-right10"
            value={1}
            checked={
              parseInt(teleMedMode) === 1 || parseInt(teleMedMode) === 0
                ? true
                : false
            }
            onChange={handleTelMedMode}
          />
          Audio & Video
          <input
            type="radio"
            name="serviceType"
            className="clear-right10 clear-left10"
            value={2}
            checked={parseInt(teleMedMode) === 2 ? true : false}
            onChange={handleTelMedMode}
          />
          Telephonic/ Audio
        </div>
      </div>
      <div className="appt-hx-fa-rw">
        <input
          type="checkbox"
          className="clear-right10"
          onChange={(e) => handleTelemed(e, 1)}
          disabled={telemed === '0'}
          checked={telemedQcode === 1}
        />
        Select, if the patient is hosted in the clinic (add Q3014).
      </div>
    </>
  );
}

export default TeleMedicineSection;
